export default __webpack_public_path__ + "static/media/css.486422b1.png";